<template>
  <div>
    <v-tooltip location="bottom center" opacity="1">
      <template #activator="{ props }">
        <v-icon class="icon-tooltip-icon-area" :class="iconClass" :color="color" :icon="icon" v-bind="props">
          {{ icon }}
        </v-icon>
      </template>
      <span v-if="!largeTooltip" class="icon-tooltip-container tooltip-multiline">
        {{ tooltipText }}
      </span>

      <div v-else class="large-tooltip-container">
        <div class="large-tooltip-title">
          <v-icon color="#ffffff" :class="largeTooltipIconClass">{{ largeTooltipIcon }}</v-icon>
          {{ largeTooltipTitle }}
        </div>
        <div class="large-tooltip-content">
          <slot> </slot>
        </div>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    tooltipText: {
      type: String,
      required: false,
    },
    largeTooltip: {
      type: Boolean,
      default: false,
    },
    largeTooltipTitle: {
      type: String,
      required: false,
    },
    largeTooltipIcon: {
      type: String,
      required: false,
    },
    largeTooltipIconClass: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/tooltip.scss';

.icon-tooltip-icon-area {
  cursor: help;
  font-size: $font-size-sm;
}
</style>
